import * as React from "react";
import {Modal} from "react-bootstrap";
import {Alert} from "../form/Alert";

interface State {
    show?: boolean
    error?: string;
    inProgress?: boolean
}

export class RemovableTagModal extends React.Component<{ tagName?: string, title?: string, iconClassName?: string; message?: string; label?: string; description?: string, onDelete: () => Promise<any>, onCancel?: () => void, className?: string }, State> {

    constructor(props) {
        super(props);
        this.state = {show: false, inProgress: false};
    }

    cancel() {
        this.setState({show: false, error: undefined});
        if (this.props.onCancel) {
            this.props.onCancel();
        }
    }

    doDelete() {
        if (this.state.inProgress == true) {
            return;
        }
        this.setState({show: false});
        if (this.props.onDelete) {
            this.setState({inProgress: true});
            let promise = this.props.onDelete();
            promise.then(() => {
                this.setState({show: false, error: undefined, inProgress: false});
            }).catch(err => {
                this.setState({show: true, error: err, inProgress: false});
            });
        }
    }

    getDeleteInfo(): any {
        if (this.state.error != null) {
            return false;
        }
        return <span>You are a about to {this.getLabel()} {this.props.description}</span>
    }

    getDeleteError(): any {
        if (this.state.error == null) {
            return false;
        }
        let text = "Unable to " + this.getLabel() + " " + this.props.description;
        return <Alert type="danger" text={text}/>
    }

    getActions() {
        if (this.state.error != null) {
            return (
                <a className="btn btn-default" onClick={this.cancel.bind(this)}>Continue</a>
            );
        }
        return (
            <div>
                <a className="btn btn-default" onClick={this.cancel.bind(this)}>Cancel</a>
                <a className="btn btn-danger" onClick={this.doDelete.bind(this)}
                   disabled={this.state.inProgress}>{this.getLabel()}</a>
            </div>
        );
    }

    getLabel() {
        if (this.props.label) {
            return this.props.label;
        }
        return "Delete";
    }

    render() {
        return (
            <span key={this.props.tagName} className={"tag badge badge-pill badge-info"} onClick={() => {
                this.setState({show: true})
            }}>
                    {this.props.tagName}
                <i className={"tag-remove fa " + (this.state.inProgress ? "fa-circle-o-notch fa-spin" : "fa-times-circle")}/>

               <Modal show={this.state.show} onHide={this.cancel.bind(this)}
                      aria-labelledby="contained-modal-title">
                   <Modal.Header closeButton>
                       <Modal.Title id="contained-modal-title">{this.props.title}</Modal.Title>
                   </Modal.Header>
                   <Modal.Body>
                       {this.getDeleteInfo()}
                       {this.getDeleteError()}
                   </Modal.Body>
                   <Modal.Footer>
                       {this.getActions()}
                   </Modal.Footer>
               </Modal>
           </span>


        );
    }
}


// WEBPACK FOOTER //
// ./src/app/ui/util/RemovableTagModal.tsx